
import { debounce } from './toolbox.js'

const debounceTime = 200
const domUpdate = new CustomEvent('domupdate')
const domUpdated = new CustomEvent('domupdated')
const body = document.body

const observer = new MutationObserver( function (mutations) {
  mutations.forEach(function(mutation) {
    if(mutation.type === 'childList') {
      body.dispatchEvent(domUpdate)
    }
  })
})
observer.observe(body, {
  childList: true, subtree: true
})

body.addEventListener('domupdate', debounce(updated, debounceTime))

function updated() {
  body.dispatchEvent(domUpdated)
}
